import type { IconProps } from "./CircleIcon";

export const DropdownArrow = ({ className }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    className={className}
  >
    <path d="M12 0.5H0L6 9.5L12 0.5Z" fill="currentColor" />
  </svg>
);
